/**
 * OnboardingProgress Component
 *
 * Visual step indicator for the onboarding wizard.
 * Shows numbered steps with completed/current/upcoming states.
 */

import { Check } from "lucide-react";
import type { OnboardingStepInfo } from "../../types/onboarding";

interface OnboardingProgressProps {
  steps: OnboardingStepInfo[];
}

export function OnboardingProgress({ steps }: OnboardingProgressProps) {
  // Only show the first 3 steps (welcome, profile, partner) — not "completed"
  const visibleSteps = steps.filter((s) => s.name !== "completed");

  return (
    <div className="flex items-center justify-center gap-2">
      {visibleSteps.map((step, index) => (
        <div key={step.name} className="flex items-center">
          {/* Step circle */}
          <div
            className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium transition-colors ${
              step.completed
                ? "bg-primary text-primary-foreground"
                : step.current
                  ? "bg-primary text-primary-foreground ring-2 ring-primary/30 ring-offset-2"
                  : "bg-muted text-muted-foreground"
            }`}
          >
            {step.completed ? <Check className="w-4 h-4" /> : index + 1}
          </div>
          {/* Connector line */}
          {index < visibleSteps.length - 1 && (
            <div
              className={`w-12 h-0.5 mx-1 ${
                step.completed ? "bg-primary" : "bg-muted"
              }`}
            />
          )}
        </div>
      ))}
    </div>
  );
}
